import Emitter from "./Emitter";

export default class SoundOn extends Emitter {
    constructor(gb) {
        super(gb);
    }

    F1X2_handler() {
        this.emitGame("audio-enable");
    }

    SLINGO_handler() {
        this.emitGame({ event: "soundOn" });
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgToggleSound", Params: "true" }));
    }

    PNG_handler() {
        this.emitGame({ messageType: "request", request: "soundOn" });
    }

    EDICT_handler() {
        this.emitGame("enableAudio");
    }

    // GSYSB_handler() {
    //     this.emitGame({ event: "soundOn"});
    // }

    // GSYSP_handler() {
    //     this.emitGame({ event: "soundOn"});
    // }

    BGS_handler() {
        this.emitGame({ event: "soundOn"});
    }

    RGU_handler() {
        this.emitGame({ event: "soundOn"});
    }

    RAW_handler() {
        this.emitGame({ event: "soundOn"});
    }

    HB_handler() {
        this.emitGame({ event: "soundOn"});
    }

    SPRIBE_handler() {
        this.emitGame({
            cmd: 'ifc.set.sound', data: {value: true},
        })
    }

    HI5_handler() {
        window.postMessage({cmd:"hi5_mute",value: false},"*");
    }

    HKS_handler() {
        this.emitGame({actionType:'toggleSound', actionData: {soundOn: true}});
    }

    SYN_handler() {
        this.emitGame({event: "p2g.gameAudioEnable"})
    }

    KAJ_handler() {
        this.emitGame({'method': 'gel.audio.enable'});
    }

    ISOFT_handler() {
        this.emitGame('UNMUTE_SOUNDS');
    }

    YGG_handler() {
        this.emitGame({event:"audio/unmute"})
    }

    PT_handler() {
        this.emitGame(JSON.stringify({
            "_type": "ucip.sound.w2gSoundUpdateNotification",
            "mute": false
        }))
    }

    HBN_handler() {
        this.emitGame({type: "audio", mute: false, level: 100})
    }

    SPIN_handler() {
        // not correct msg
        this.emitGame({"event":"volume","isOn":true})
    }

    ENDOR_handler() {
        this.emitGame({
            messageId: "updateSettings",
            mute: false
        });
    }

    HABANERO2_handler(){
        this.emitGame({type: "audio", mute: false, level: 100})
    }

    _default() {
        this.emitGame({ wpgaction: "soundOn" });
    }
}
